import React from 'react';
import { blockIfReadOnly } from '../../../../core/accessControl/guard';
import { button } from './variants';

interface MemoryButtonProps {
  label: string | React.ReactNode;
  variant: 'primary' | 'secondary' | 'outline';
  error?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  /**
   * Libera o clique no modo somente-leitura do freemium. Use em botões de
   * navegação/visualização e no fluxo de upsell/checkout. Sem isso, no modo
   * somente-leitura o clique abre o modal de upsell em vez de executar.
   */
  allowReadOnly?: boolean;
}

function extractText(node: React.ReactNode): string {
  if (node === null || node === undefined || typeof node === 'boolean') {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractText).join(' ');
  }
  if (React.isValidElement(node)) {
    return extractText((node.props as { children?: React.ReactNode }).children);
  }
  return '';
}

const MemoryButton = ({
  label,
  variant,
  error,
  onClick,
  disabled,
  className,
  icon,
  allowReadOnly = false,
}: MemoryButtonProps) => {
  // Botões com texto "como funciona" são informativos e ficam sempre
  // liberados no modo somente-leitura do freemium.
  const isHowItWorks = /como funciona/i.test(extractText(label));

  const onClickHandler = () => {
    if (disabled) return;
    if (!allowReadOnly && !isHowItWorks && blockIfReadOnly()) return;
    onClick?.();
  };
  return (
    <button
      onClick={onClickHandler}
      className={button({ variant, error, disabled, className })}
      disabled={disabled}
    >
      {icon}
      {label}
    </button>
  );
};

export default MemoryButton;
